// extracted by mini-css-extract-plugin
export default {"content":"content--Bw4ns","center":"center--sNuFA","left":"left--LT71H","right":"right--wyHJE"};